'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _SwapOutlined = _interopRequireDefault(require('./lib/icons/SwapOutlined'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _SwapOutlined;
  exports.default = _default;
  module.exports = _default;